<template>
  <div class="chart-container">
    <button
      v-if="!isObjectEmpty(drilldown) && drilldownActive"
      @click="handleBackButtonClick"
      class="back-button"
    >
      {{ $t("back") }}
    </button>
    <div ref="chart" class="chart amchart"></div>
    <div ref="legend" class="legend"></div>
  </div>
</template>

<script>
/* eslint-disable */

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    drilldown: {
      type: Object,
      default() {
        return {};
      }
    },
    currency: {
      type: String,
      default: ""
    },
    total: {
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      chart: null,
      drilldownActive: false
    };
  },
  watch: {
    data() {
      this.rebuildChart();
    },
    currency() {
      this.rebuildChart();
    },
    total(value) {
      // console.log(this.chart);
      // this.createCenterLabel(this.chart.series, value, this.currency);
      // this.chart.series.label = "AAAA";
    },
    drilldownActive(value) {
      if (!value) {
        this.$emit("drilldown-status", { category: value });
      }
    }
  },
  methods: {
    createCenterLabel(series, total, currency) {
      if (this.data.length === 0) {
        return series;
      }
      let label = series.createChild(am4core.Label);
      label.text = `${total} ${currency}`;
      label.horizontalCenter = "middle";
      label.verticalCenter = "middle";
      // Подбираем размер шрифта для текста в центре графика
      let totalLength = String(total).length;
      if (totalLength < 6) {
        label.fontSize = 30;
      } else if (totalLength < 11) {
        label.fontSize = 20;
      } else if (totalLength < 15) {
        label.fontSize = 20;
      } else {
        label.fontSize = 17;
      }
      return series;
    },
    createLegend(chart) {
      chart.legend = new am4charts.Legend();
      let legendContainer = am4core.create(
        this.$refs.legend,
        am4core.Container
      );
      legendContainer.width = am4core.percent(100);
      legendContainer.height = am4core.percent(100);
      chart.legend.parent = legendContainer;
      return chart;
    },
    createSeries(chart) {
      let series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = "value";
      series.dataFields.category = "category";
      // Отключаем отображение label'ов
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;
      series.slices.template.tooltipText = `{category}: {value} ${
        this.currency
      }`;
      series = this.createCenterLabel(series, this.total, this.currency);
      // Добавляем drilldown, если данные drilldown были переданы
      series = this.addDrilldown(series);
      return chart;
    },
    addDrilldown(series) {
      series.slices.template.events.on(
        "hit",
        e => {
          let selectedCategoryName = e.target.dataItem.category;
          this.$emit("drilldown-status", { category: selectedCategoryName });
          if (this.drilldown[selectedCategoryName]) {
            this.chart.data = this.drilldown[selectedCategoryName];
            this.drilldownActive = true;
          }
        },
        this
      );
      return series;
    },
    isObjectEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    handleBackButtonClick() {
      this.chart.data = this.data;
      this.drilldownActive = false;
    },
    initChart() {
      let chart = am4core.create(this.$refs.chart, am4charts.PieChart);
      chart = this.createSeries(chart);
      chart.data = this.data;
      chart.innerRadius = am4core.percent(50);
      chart = this.createLegend(chart);
      chart.svgContainer.height = "500px";
      this.chart = chart;
    },
    destroyChart() {
      if (this.chart) {
        this.chart.dispose();
      }
    },
    rebuildChart() {
      this.destroyChart();
      this.initChart();
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    this.destroyChart();
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
}
.chart {
  min-height: 40vh;
  width: 100%;
}

.back-button {
  position: absolute;
  padding: 10px 15px;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 5;
}

.legend {
  padding: 20px 0;
}
</style>
